import {
  GET_PERSONALIZATION,
  GET_PERSONALIZATION_SUCCESS,
  GET_PERSONALIZATION_ERROR,
  UPDATE_USER_ATTRIBUTES,
  UPDATE_USER_ATTRIBUTES_SUCCESS,
  UPDATE_USER_ATTRIBUTES_ERROR,
} from "../../constants/action-types";
import { ApiService } from "../../util/ApiService";
import config from "../../util/api-config";
import { showErrorMsg } from ".";

const gateRequester = new ApiService(config.personalizationEdge);

export const getPersonalizationInfo = (dispatch) => {
  window.sessionStorage.removeItem("search-result");
  window.sessionStorage.removeItem("search-result-query");
  dispatch({ type: GET_PERSONALIZATION });
  return (
    gateRequester
      //adding a query for time stamp to prevent browser side caching
      .get(`/`)
      .then((response) => {
        const data = response?.data;
        if (data) {
          if (data.userHeader?.puaDialog) {
            const shouldNotShowPuaDialog = !!document.cookie
              .split("; ")
              .find((item) => item.indexOf("puaReminderModalShown") === 0);
            if (shouldNotShowPuaDialog) {
              delete data.userHeader.puaDialog;
            } else {
              document.cookie = `puaReminderModalShown=true; SameSite=None; Secure`;
            }
          }
          dispatch({
            type: GET_PERSONALIZATION_SUCCESS,
            payload: data,
          });
        } else {
          dispatch({ type: GET_PERSONALIZATION_ERROR });
        }
      })
      .catch(() => dispatch({ type: GET_PERSONALIZATION_ERROR }))
  );
};

export const updateUserAttributes = (dispatch, attributes) => {
  dispatch({ type: UPDATE_USER_ATTRIBUTES });
  return gateRequester
    .put(`/user-attributes`, attributes)
    .then(() => {
      dispatch({ type: UPDATE_USER_ATTRIBUTES_SUCCESS });
      window.location.reload();
    })
    .catch(() => {
      dispatch({ type: UPDATE_USER_ATTRIBUTES_ERROR });
      showErrorMsg(dispatch);
    });
};
